//ApplicationAuditService.ts
import axios from "axios";
import { ApplicationAuditType } from "../pages/ApplicationAudit/data/ApplicationAuditType";
import { ApplicationAuditListResponse } from "../type/response/ApplicationAuditListResponse";
import { axiosRequest } from "./AxiosService";

/**
 * 申請審査一覧データを取得し、表示用の形式に変換して返す
 * @returns 申請審査一覧データ、取得失敗時は空配列
 */
export const fetchApplicationAuditList = async(): Promise<ApplicationAuditType[]> => {
    try {
      const response = await axiosRequest<ApplicationAuditListResponse>(
        "/applicationAuditList/getAuditList",
        "GET",
      );

      // ApplicationAuditListResponse → ApplicationAuditType に変換
      const convertedData = (response.applicationAuditList || []).map(data => {
        // richTextタイプのデータを抽出してMapに格納
        const richTextMap: Record<string, string> = {};
        data.formEntryList
          ?.filter(f => f.type === 'richText')
          .forEach(f => {
            richTextMap[f.label] = f.value || '';
          });

        return {
          applicationEntryId: data.applicationEntryId ?? '',
          number: data.number ?? '',
          submittedAt: data.submittedAt,
          type: data.type,
          applicationName: data.applicationName,
          // 申請者名: lastName + firstName
          applicant: `${data.applicant?.lastName ?? ''} ${data.applicant?.firstName ?? ''}`,
          // 申請者情報: key: value形式で改行区切り
          userProfiles: data.applicant?.profileList?.map(p => `${p.key}: ${p.value}`).join('\n') ?? '',
          status: data.status ?? '',
          // 現在のアクティビティ: status='InProgress'のものを抽出
          currentActivity: data.activityList?.find(a => a.status === 'InProgress')?.activityName ?? '',
          // 申請内容: itemOrderで並び替えてlabel: value形式で改行区切り
          formSummary: data.formEntryList
            ?.sort((a, b) => (a.itemOrder ?? 0) - (b.itemOrder ?? 0))
            .map(f => {
              // linkList タイプの場合、formLinks を使用
              if (f.type === 'linkList' && f.formLinks && f.formLinks.length > 0) {
                const links = f.formLinks
                  .sort((a, b) => a.order - b.order)
                  .map(link => `${link.description}: ${link.url}`)
                  .join('\n');
                return `${f.label}:\n${links}`;
              }
              // richText タイプの場合、labelのみ（値は前端で処理）
              if (f.type === 'richText') {
                return `${f.label}: [リッチテキスト]`;
              }
              // 通常の場合
              return `${f.label}: ${f.value}`;
            })
            .join('\n') ?? '',
          // richTextのデータを保持
          richTextMap: Object.keys(richTextMap).length > 0 ? richTextMap : undefined,
          // 添付ファイル: 有 or 無
          // formEntryListの中にtype="fileUpload"でvalueが空でないものがあれば「有」
          reportFileStatus: data.formEntryList?.some(
            f => f.type === 'fileUpload' && f.value && (Array.isArray(f.value) ? f.value.length > 0 : true)
          ) ? '有' : '無',
        };
      });

      return convertedData;

    } catch (error) {
      console.error("データ取得中にエラーが発生しました", error);
      return [];
    }
  }